import styled from 'styled-components';
/* eslint-disable max-lines */

export const ScrollContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  scrollbar-width: none;
`;
export const BannerContainer = styled.div`
  position: relative;
  width: 100%;
  height: 400px;
`;
export const Banner = styled.img`
  width: 100%;
  height: 400px;
  border-radius: 15px;
  overflow: hidden;
  object-fit: cover;
  box-sizing: border-box;
`;
export const FreeAccess = styled.span`
  position: absolute;
  left: 12px;
  bottom: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 600;
  color: #FFF;
  background: rgb(26, 93, 13);
`;
export const FreePlaces = styled.span`
  position: absolute;
  left: 12px;
  bottom: 12px;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 600;
  color: #FFF;
  background: #1C1C1C;
`;

export const Title = styled.h3`
  font-size: 18px;
  line-height: 1.5; 
  font-weight: 500;
  color: #323131;
`;

export const FormsTitle = styled.h3`
  font-size: 18px;
  line-height: 1.5; 
  font-weight: 500;
  color: #323131;
  margin-bottom:5px;
`;

export const Text = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  padding:10px;
`;
export const LabelsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
`;
export const Label = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  border-radius: 10px;
  padding: 5px 10px;
  background-color: #E4E4E7; 
`;
export const PdfContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  border-radius: 10px;
  padding: 5px 10px;
  background-color: #1C1C1C;
  cursor: pointer;
`;
export const PdfText = styled.span`
  color: #FFF;
  font-size: 14px;
  line-height: 1.7;
  font-weight: 400;
`;
export const LabelText = styled.span`
  color: #1C1C1C;
  font-size: 14px;
  line-height: 1.7;
  font-weight: 400;
`;
export const Description = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  padding:10px;
`;
export const LoaderTitle = styled.span`
  color: #1C1C1C;
  font-size: 16px;
  line-height:1.7;
  font-weight: 400;
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px;
  width: 100%;
  min-height: 200px;
  border-radius: 15px;
  gap: 12px;
  background: #F4F4F5;
`;
export const FormTitle = styled.span`
  color: #1C1C1C;
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
`;
export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;
export const InputsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  gap: 12px;
`;
export const FormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;
export const PersonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-width: 270px;
  padding: 5px;
  border-radius: 8px;
`;
export const ActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  min-width: 270px;
  padding: 5px;
  border-radius: 8px;
`;
export const PersonTitle = styled.span`
  color: #1C1C1C;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`;
export const CounterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
`;
export const CounterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px; 
  background-color: #C18244;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  width: 30px;
  height:30px;
  color: #FFF;
`;
export const TrashButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color:rgba(82, 82, 91, 0.42);
  border-radius: 25px;
  border: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  color: #FFF;
`;
export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px; 
  background-color: #1c1c1c;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  flex:1;
  height: 40px;
  color: #FFF;
`;

export const Input = styled.input<{ error?: string }>`
  width: 100%;
  height: 45px;
  min-width: 150px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 2px solid #FFF;
  background: #FFF;
  color: #1C1C1C;
  font-size: 14px;
  line-height:1.7;
  font-weight: 400;
  box-sizing: border-box;
  flex: 1;
  position: relative;
  margin-bottom: 12px;
  
  ${({ error }) => error && `
    border-color: red;
  `}
`;

export const ErrorText = styled.div`
  color: red;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 8px;
`;
export const StatusText = styled.span`
  font-size: 14px;
  line-height: 1.7;
  color: #52525B;
`;
export const StatusImage = styled.img`
  height: 100px;
  width: 100px;
  margin: 0 auto;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  min-height: 200px;
  width: 100%;
  border-radius: 15px;
  gap: 12px;
  background: #F4F4F5;
`;
